var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { useState } from "react";
import { ToggleInput } from "./input.styles";
// utils
import { makeDataTestIdGetter } from "../utils";
export const ToggleInputWrapper = (_a) => {
    var { children, dataTestIdPrefix } = _a, props = __rest(_a, ["children", "dataTestIdPrefix"]);
    const [focused, setFocused] = useState(false);
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    return (_createElement(ToggleInput, Object.assign({}, props, { key: props.key, onMouseDown: () => {
            setFocused(false);
        }, onKeyUp: (e) => {
            setFocused(true);
            if (props.onKeyUp) {
                props.onKeyUp(e);
            }
        }, onBlur: (e) => {
            setFocused(false);
            if (props.onBlur) {
                props.onBlur(e);
            }
        }, focused: focused, "data-testid": getDataTestId("toggle-input") })));
};
